import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IMaskMixin } from 'react-imask';
import LocalizedText from '@LocalizedText';
import './ResizeTool.scss';
import useIntlMessage from '@app/hooks/use-intl-message';

const MaskedInput = IMaskMixin(({ inputRef, ...props }) => <input {...props} ref={inputRef} />);
const handleDragStart = e => {
  e.preventDefault();
  e.stopPropagation();
};

const ResizeInput = ({
  side,
  values,
  errors,
  locale,
  handleChange,
  handleBlur,
  handleKeyPress,
  titleKey,
  inputAriaLabelLocaleKey,
}) => {
  const fieldProps = {
    mask: Number,
    scale: values.unitScale,
    radix: '.',
    mapToRadix: [','],
    unmask: true,
    min: 0,
    max: 999999,
  };

  const [selectSizeAriaLabel] = useIntlMessage(inputAriaLabelLocaleKey);

  return (
    <div className={classnames('resize-tool-container', { invalid: errors[side] })}>
      <div className="resize-tool-wrapper">
        <label className="resize-tool-title" htmlFor={`resize-tool-${side}`}>
          <LocalizedText id={titleKey} tagName="span" />
        </label>
        <div className={classnames('resize-tool', side, locale, { invalid: errors[side] })} aria-label={selectSizeAriaLabel}>
          <MaskedInput
            {...fieldProps}
            name={side}
            id={`resize-tool-${side}`}
            aria-label={selectSizeAriaLabel}
            value={JSON.stringify(values[side])}
            invalid={JSON.stringify(errors[side])}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyPress={handleKeyPress}
            onDragStart={handleDragStart}
          />
        </div>
      </div>
      <div className="resize-tool-invalid-label">
        <LocalizedText
          id={`qau-field-validation-${locale}`}
          values={{
            min: values.sideMin,
            max: values.sideMax,
          }}
        />
      </div>
    </div>
  );
};

ResizeInput.propTypes = {
  titleKey: PropTypes.string.isRequired,
  side: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  inputAriaLabelLocaleKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
};

export default ResizeInput;
